var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5556 0L16 4.5V17.1072C15.9998 17.3441 15.9067 17.5712 15.7412 17.7386C15.5757 17.906 15.3513 18 15.1173 18H0.882667C0.649225 17.9984 0.425793 17.9038 0.260638 17.7367C0.0954826 17.5697 0.00186191 17.3436 0 17.1072V0.8928C0 0.3996 0.395556 0 0.882667 0H11.5556ZM8 8.55C8.58937 8.55 9.1546 8.31295 9.57135 7.89099C9.9881 7.46903 10.2222 6.89674 10.2222 6.3C10.2222 5.70326 9.9881 5.13097 9.57135 4.70901C9.1546 4.28705 8.58937 4.05 8 4.05C7.41063 4.05 6.8454 4.28705 6.42865 4.70901C6.0119 5.13097 5.77778 5.70326 5.77778 6.3C5.77778 6.89674 6.0119 7.46903 6.42865 7.89099C6.8454 8.31295 7.41063 8.55 8 8.55ZM4.024 13.5H11.976C11.8682 12.5086 11.4029 11.5922 10.6693 10.9267C9.93558 10.2611 8.98511 9.89299 8 9.89299C7.01489 9.89299 6.06442 10.2611 5.33074 10.9267C4.59705 11.5922 4.13175 12.5086 4.024 13.5Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentUser);
export default __webpack_public_path__ + "static/media/document_user.122b23386273774a537ca3450411b64d.svg";
export { ForwardRef as ReactComponent };